module.exports = __webpack_public_path__ + "static/media/img3-4.dd8c7bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/biosense/diff/img3-4.png
// module id = 1532
// module chunks = 3